import React from 'react';
import { Typography } from '@mui/material';

import { useStylesModalOffer } from './hooks/useStyles';
import { thousands } from '../../../../../utils/utils';
import { IProduct, PriceValue } from '../../../../../interfaces/product';
import { ReactComponent as Building } from '../../../../../../_base/layout/assets/layout-svg-icons/building-01.svg';
import { ReactComponent as Box } from '../../../../../../_base/layout/assets/layout-svg-icons/box.svg';
import { ReactComponent as Truck } from '../../../../../../_base/layout/assets/layout-svg-icons/truck-01.svg';
import ProductCount from '../ProductCount';

export function OffersForBuyerGrid({
  prices,
  product,
}: {
  prices: PriceValue[];
  product: IProduct;
}) {
  const { classes } = useStylesModalOffer();
  return (
    <div className={classes.containerOffersGrid}>
      {prices.map((i, index) => (
        <div key={index} className={classes.offerTableGrid}>
          <Typography
            component='p'
            className={classes.vendorTitle}
            style={{ fontWeight: 'normal', fontSize: 16 }}
          >
            {i.vendor?.code ? `Склад ${i.vendor.code}` : `Склад ${index + 1}`}
          </Typography>
          <ProductCount
            showPrice
            product={product}
            priceBold
            priceValue={i}
            style={{ flexDirection: 'column', gap: 15 }}
          />
          <div className={classes.containerPricesGrid}>
            {i.prices?.map(item => (
              <div className={classes.priceGrid}>
                <Typography component='p' className={classes.price}>
                  {`от ${item.amount} шт.`}
                </Typography>
                <div className={classes.onceColumn}>
                  <Typography component='p' className={classes.priceBold}>
                    {thousands(String(item.price || '0'))}
                  </Typography>
                  <Typography className={classes.rub} component='p'>
                    <span className={classes.rub}>₽</span>
                  </Typography>
                </div>
              </div>
            ))}
          </div>
          <div className={classes.containerOffersTable}>
            <div className={classes.containerStock}>
              <div className={classes.containerTitle}>
                <Building />
                <Typography className={classes.gridQuantityTitle} component='p'>
                  Наличие на складе
                </Typography>
                <Typography className={classes.gridQuantityValue} component='p'>
                  {`${thousands(String(i.vendor?.stock_quantity || '0'))} шт.`}
                </Typography>
              </div>
              <div className={classes.containerTitle}>
                <Truck />
                <Typography className={classes.gridQuantityTitle} component='p'>
                  Срок поставки
                </Typography>
                <Typography className={classes.gridQuantityValue} component='p'>
                  1 нед.
                </Typography>
              </div>
            </div>
            <div className={classes.containerStock}>
              <div className={classes.containerTitle}>
                <Box />
                <Typography className={classes.gridQuantityTitle} component='p'>
                  Количество под заказ
                </Typography>
                <Typography className={classes.gridQuantityValue} component='p'>
                  {`${thousands(String(i.vendor?.order_quantity || '0'))} шт.`}
                </Typography>
              </div>
              <div className={classes.containerTitle}>
                <Truck />
                <Typography className={classes.gridQuantityTitle} component='p'>
                  Срок поставки
                </Typography>
                <Typography className={classes.gridQuantityValue} component='p'>
                  {`${thousands(String(i.vendor?.delivery_period || '0'))} нед.`}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
